<template>
  <component :is="showPage" v-if="pageType" />
</template>

<script>
import {
  defineComponent,
  computed,
  onMounted,
  ref,
} from "@vue/composition-api";

import { useStore } from "@/components/use/base";

import CommonMember from "./page/CommonMember.vue";
import Weicai from "./page/Weicai.vue";
import JiaYing from "./page/JiaYing.vue";
import Xyr from "./page/Xyr.vue";
import Xxn from "./page/Xxn.vue";
import Jixiaoman from "./page/Jixiaoman.vue";

export default defineComponent({
  components: {
    CommonMember,
    Weicai,
    JiaYing,
    Xyr,
    Xxn,
    Jixiaoman,
  },
  setup() {
    const pageType = ref("");
    const store = useStore();

    const showPage = computed(() => {
      return pageType.value;
    });

    const namespaceGroup = computed(
      () => store.state.namespaceInfo.namespace_group_en
    );

    onMounted(() => {
      pageType.value =
        {
          weicai: "Weicai",
          jiayin: "JiaYing",
          zhongji: "Xyr",
          xinxiaoniu: "Xxn",
          jixiaoman: "Jixiaoman",
        }[namespaceGroup.value] || "CommonMember";
    });

    return { showPage, pageType };
  },
});
</script>

<style scoped lang="less">
</style>
